// src/pages/Home.jsx
import React from "react";

// Seções da Home
import Hero from "../components/sections/Home/Hero";
import Sobre from "../components/sections/Home/Sobre";
import ProjectGallery from "../components/sections/Home/ProjectGallery";
import Diferenciais from "../components/sections/Home/Diferenciais";
import Problemas from "../components/sections/Home/Problemas";
import CallToAction from "../components/sections/Home/CallToAction";

// Estilos da Home
import "../Styles/hero.css";
import "../Styles/sobre.css";
import "../Styles/projectGallery.css";
import "../Styles/diferenciais.css";
import "../Styles/problemas.css";
import "../Styles/cta.css";

const HomePage = ({ phone }) => {
  return (
    <main style={{ overflow: "hidden" }}>
      <Hero />
      <Sobre phone={phone} />
      <ProjectGallery />
      <Diferenciais />
      <Problemas />
      <CallToAction phone={phone} />
    </main>
  );
};

export default HomePage;
